// Default Values
export const FeatureFlags = {
  SupportToolProviderEnabled: false,
  ForceNewValidationRequestEnabled: false
};
